import { useState } from 'react';
import { faqs } from '../../../mocks/guaData';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-widest text-accent-600">F.A.Q</p>
          <h3 className="mt-2 text-2xl font-black text-foreground-950 md:text-3xl">关于反差吃瓜，你可能想问</h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            从「什么是反差吃瓜」到更新频率、信源核实、投稿与免费机制，这里统一解答你最关心的问题。如果还没找到答案，
            <a href="#subscribe" className="font-bold text-primary-600 hover:underline">
              订阅速报
            </a>
            或留言给我们。
          </p>
          <div className="mt-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-100 text-2xl text-accent-700">
            <i className="ri-question-line" aria-hidden="true"></i>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border transition ${
                    isOpen ? 'border-primary-200 bg-primary-50/40' : 'border-background-200 bg-background-50'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-bold text-foreground-900">{f.q}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`} aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="border-t border-primary-100 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}